import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import DialogActions from "@mui/joy/DialogActions";
import Button from "@mui/joy/Button";
import AutorenewRoundedIcon from "@mui/icons-material/AutorenewRounded";

const RestorePopup = ({ open, setOpen, label, handleRestore }) => {
  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <ModalDialog
        variant="outlined"
        role="alertdialog"
        sx={{
          borderRadius: "16px",
          p: 3,
          width: 360,
          textAlign: "center",
          maxHeight: "80vh",
          overflowY: "auto",
        }}
      >
        {/* Icon */}
        <AutorenewRoundedIcon
          sx={{
            fontSize: 50,
            color: "#2e7d32",
            mb: 1,
            backgroundColor: "#e8f5e9",
            borderRadius: "50%",
            p: 1,
          }}
        />

        {/* Title */}
        <DialogTitle sx={{ fontWeight: "bold", fontSize: "18px" }}>
          Restore Product
        </DialogTitle>

        {/* Content */}
        <DialogContent
          sx={{
            fontSize: "14px",
            color: "text.secondary",
            textAlign: "start",
            px: 0,
          }}
        >
          {label || "Are you sure you want to restore this product?"}
        </DialogContent>

        {/* Actions */}
        <DialogActions sx={{ justifyContent: "center", gap: 2 }}>
          <Button
            variant="outlined"
            color="neutral"
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>

          <Button
            variant="solid"
            color="success"
            onClick={handleRestore}
          >
            Restore
          </Button>
        </DialogActions>
      </ModalDialog>
    </Modal>
  );
};

export default RestorePopup;